import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import AddButton from 'shared/ui/AddButton';
import { redirect } from 'store/Router/actions';
import { newPipeline } from 'store/Pipelines/actions';

const CreateButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(redirect('/automation/pipelines/new'));
    dispatch(newPipeline());
  };
  return (
    <AddButton title="Create" onClick={ handleClick }>
      {intl.formatMessage({ id: 'pipelines.list.header.createButton' }) }
    </AddButton>
  );
};

export default CreateButton;
